var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKaHausgarten(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#5a4146;}.cls-3{fill:#996123;}.cls-4{fill:#ffe532;}.cls-5{fill:#ddeaf1;}.cls-6{fill:#bddfff;}.cls-7{fill:#305895;}.cls-8{fill:#1b3558;}.cls-9{fill:#add47f;}.cls-10{fill:#76b72a;}.cls-11{fill:#ffba36;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Maske"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 160,
    height: 160,
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M143.56,90.27v8.15h-8.87V90.27h-8.43v8.15H113.94v8.46h12.32v11.65h8.43V106.88h8.87v11.65H152V90.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M46.06,98.42H33.74V90.27H25.31v8.15H16.44V90.27H8v28.26h8.44V106.88h8.87v11.65h8.43V106.88H46.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M134.69,32.6A15.56,15.56,0,1,1,119.13,17a15.59,15.59,0,0,1,15.56,15.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M117.39,70.86V123.2H42.61V69.83h4.22L80,54.56l33.17,16.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M117.39,70.86V123.2H80V54.56l33.17,16.3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 66.85,
    y: 88.3,
    width: 26.31,
    height: 30.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 80,
    y: 88.3,
    width: 13.15,
    height: 30.67
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M126,71.22l-3.89,7.5L80,56.7l-42.14,22L34,71.22,80,47.16Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 8,
    y: 114.74,
    width: 144,
    height: 28.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 80,
    y: 114.74,
    width: 72,
    height: 28.25
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M126,71.22l-3.89,7.5L80,56.7V47.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M134.69,32.6a15.59,15.59,0,0,1-15.56,15.6V17a15.6,15.6,0,0,1,15.56,15.6Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKaHausgarten);
export default __webpack_public_path__ + "static/media/ka_haus+garten.dfb17b6d083f76e086942363c8e3faa6.svg";
export { ForwardRef as ReactComponent };